import { Middleware } from '@reduxjs/toolkit';

const actionTracker = new Set<string>();

const infiniteLoopDetector: Middleware = () => (next) => (action) => {
  const typedAction = action as { type: string }; // Explicitly cast action

  if (typeof typedAction.type !== 'string') {
    return next(action); // Ignore actions without a valid type
  }

  if (actionTracker.has(typedAction.type)) {
    console.warn(`⚠️ Possible Infinite Loop Detected: ${typedAction.type}`);
  } else {
    actionTracker.add(typedAction.type);

    // Remove the action from the tracker after 1 second
    setTimeout(() => actionTracker.delete(typedAction.type), 1000);
  }

  return next(action);
};

export default infiniteLoopDetector;
